import React from 'react';

import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import reduxUtils from 'util/redux';
import AnimatedCounter from 'components/animated-counter/index';
import Icon from 'components/icon';
import Cart from 'components/cart/index';
import { all } from 'util/dom/handle-accessible-key-events';
import t from 'translations/index';
import { formatPrice } from 'util/misc/format-price';
import { CURRENCY } from 'constants/cart';

function HeaderCart({ totalItemsPrice, bagInfo, isDesktop, isPanelOpen, panelFacet, togglePanel }) {
    const toggleCart = () => togglePanel({ facet: 'cart', content: <Cart/> });

    return (
        <div onClick={toggleCart}
            className="header-cart grid">
            <div className="grid--row header-cart--row">
                <button className="header-cart--accessibility-button"
                    aria-haspopup="true"
                    aria-controls="menu"
                    aria-pressed={isPanelOpen && panelFacet === 'cart'}
                    onKeyDown={e => all(e) && toggleCart(e)}>
                    {t('cart.cart')}
                </button>
                {isDesktop ? <div
                    className="header-cart--price grid--col">{CURRENCY} {formatPrice(totalItemsPrice)}</div> : null}
                <div className="header-cart--bags grid--col">
                    <Icon symbol="cart" size="large" className="header-cart--bag-image"/>
                    {bagInfo.total_bags ?
                        <AnimatedCounter ariaLabel={t('accessibility.label.cart_value')} readonly={true} suffix="×"
                            className="header-cart--bag-info"
                            amount={bagInfo.total_bags}/> : null}
                </div>
            </div>
        </div>
    );
}

HeaderCart.propTypes = {
    isDesktop: PropTypes.bool.isRequired,
    totalItemsPrice: PropTypes.string.isRequired,
    togglePanel: PropTypes.func.isRequired,
    isPanelOpen: PropTypes.bool.isRequired,
    panelFacet: PropTypes.string,
    bagInfo: PropTypes.object.isRequired,
    isModalVisible: PropTypes.bool.isRequired,
    isSearchVisible: PropTypes.bool.isRequired,
    wasCartFetched: PropTypes.bool.isRequired,
};

export default connect(
    reduxUtils.mapStateToProps({
        totalItemsPrice: 'cart.totalItemsPrice',
        bagInfo: 'cart.bagInfo',
        isPanelOpen: 'panel.isOpen',
        panelFacet: 'panel.facet',
        isDesktop: 'viewport.isDesktop',
        isModalVisible: 'modal.isVisible',
        wasCartFetched: 'cart.wasFetched',
        isSearchVisible: 'search.isActive',
    }),
    reduxUtils.mapDispatchToProps({
        togglePanel: 'panel.toggle',
    }),
)(HeaderCart);



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/components/main-header/header-cart/index.js